import { render, staticRenderFns } from "./UsuariosDetalle.vue?vue&type=template&id=d310793c&scoped=true"
import script from "./UsuariosDetalle.vue?vue&type=script&lang=js"
export * from "./UsuariosDetalle.vue?vue&type=script&lang=js"
import style0 from "./UsuariosDetalle.vue?vue&type=style&index=0&id=d310793c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d310793c",
  null
  
)

export default component.exports